import React, { DetailedHTMLProps, InputHTMLAttributes, useState } from 'react';

type Value = string | number | undefined;
type InputProps<T extends Value> = { initialValue: T; onSubmit?: (value: T) => Promise<void> };

type UseInputResult<T extends Value> = Pick<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'onChange' | 'onBlur' | 'onKeyDown'
> & { value: T; onValueChange: (value: T) => void };

export default function useInput<T extends Value>({ initialValue, onSubmit }: InputProps<T>): UseInputResult<T> {
    const [value, setValue] = useState<T>(initialValue);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value as T);
    };

    const handleSubmit = () => {
        if (typeof onSubmit === 'function') {
            onSubmit(value).catch(() => setValue(initialValue));
        }
    };

    return {
        value,
        onChange: handleChange,
        onBlur: () => handleSubmit(),
        onKeyDown: (e) => {
            if (e.key === 'Enter') {
                handleSubmit();
            }
        },
        onValueChange: setValue,
    };
}
